import { useRef, useEffect, useState } from "react";
import {
  ProjectWrapper,
  SectionEightWrapper,
  SectionFifteenWrapper,
  SectionFourWrapper,
  SectionOneWrapper,
  SectionSeventeenWrapper,
  SectionSevenWrapper,
  SectionThirteenWrapper,
  SectionThreeWrapper,
  SectionTwoWrapper,
} from "./styled";

import {
  Box,

  IconButton,
  Theme,
  Typography,
  Dialog,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import Databass1 from "../../Assets/images/databass1.png";
import Databass2 from "../../Assets/images/databass2.png";
import Databass3 from "../../Assets/images/databass3.png";
import Databass4 from "../../Assets/images/databass4.png";
import Databass5 from "../../Assets/images/databass5.png";
import Databass6 from "../../Assets/images/databass6.png";
import Databass7 from "../../Assets/images/databass7.png";
import Databass8 from "../../Assets/images/databass8.png";
import DatabassUser1 from "../../Assets/images/databass_user1.png";
import DatabassUser2 from "../../Assets/images/databass_user2.png";
import Databass80 from "../../Assets/images/databass80.png";
import Databass40 from "../../Assets/images/databass40.png";
import Databass50 from "../../Assets/images/databass50.png";
import Databass60 from "../../Assets/images/databass60.png";
import Databass70 from "../../Assets/images/databass70.png";
import Databass100 from "../../Assets/images/databass100.png";
import Databass101 from "../../Assets/images/databass101.png";



import { AnimationOnScroll } from "react-animation-on-scroll";
import {
  East,
  PauseRounded,
  PlayArrowRounded,
  Add,
  Remove,
} from "@mui/icons-material";
import { useLocation } from "react-router-dom";

import SmileIcon from "../../Assets/Icons/SmileIcon";
import Line2 from "../../Assets/Icons/Line2";
import { scrollTrigger } from "../../Helper/scrollAnimation";

import ToolTipIcons from "../../Assets/Icons/ToolTipIcons";
import CircleIcon from "../../Assets/Icons/CircleIcon";
import TriangleIcon from "../../Assets/Icons/TriangleIcon";
import SqaureIcon from "../../Assets/Icons/SqaureIcon";

import withAuth from "../../HOC/withAuth";
import SoundExample from "../../Assets/Icons/SoundExample";
import Lines from "../../Assets/Icons/Lines";
import Before from "../../Assets/sound/before.wav";
import After from "../../Assets/sound/after.wav";
import useSound from "use-sound";
import { AudioVisualizer } from "react-audio-visualize";

const Project4 = () => {
  const { pathname } = useLocation();

  const [playing, setPlaying] = useState(false);
  const [playing2, setPlaying2] = useState(false);
  const [blob, setBlob] = useState<any>();
  const [blob2, setBlob2] = useState<any>();
  const visualizerRef = useRef<HTMLCanvasElement>(null);
  const visualizer2Ref = useRef<HTMLCanvasElement>(null);
  const [play, { stop }] = useSound(Before);
  const [play2, playOptions] = useSound(After);
  const images = [Databass100, Databass101, Databass60, Databass80, Databass70];

  // ADD THESE NEW STATE VARIABLES:
  const [expandedItems, setExpandedItems] = useState<Record<string, boolean>>(
    {}
  );

  const toggleExpanded = (itemKey: string) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemKey]: !prev[itemKey],
    }));
  };

  // ─── State for zoomable screenshots ───────────────────────────────────
  const [zoomSrc, setZoomSrc] = useState<string | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://t.contentsquare.net/uxa/bb781a00c0c07.js";
    script.async = true;
    document.head.appendChild(script);
  
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      scrollTrigger(".lineAnimation");
    });
    getFiles();
  }, []);

  // ADD THIS ENTIRE NEW useEffect HERE:
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!zoomSrc) return;

      const currentIndex = images.indexOf(zoomSrc);

      switch (event.key) {
        case "ArrowLeft":
        case "ArrowUp":
          event.preventDefault();
          const prevIndex =
            currentIndex > 0 ? currentIndex - 1 : images.length - 1;
          setZoomSrc(images[prevIndex]);
          break;
        case "ArrowRight":
        case "ArrowDown":
          event.preventDefault();
          const nextIndex =
            currentIndex < images.length - 1 ? currentIndex + 1 : 0;
          setZoomSrc(images[nextIndex]);
          break;
        case "Escape":
          event.preventDefault();
          setZoomSrc(null);
          break;
      }
    };

    if (zoomSrc) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [zoomSrc, images]);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      scrollTrigger(".lineAnimation");
    });
    getFiles();
  }, []);

  const getFiles = async () => {
    const file = await fetch("/files/before.wav");
    file.blob().then((blobData) => setBlob(blobData));

    const file2 = await fetch("/files/after.wav");
    file2.blob().then((blobData) => setBlob2(blobData));
  };

  return (
    <ProjectWrapper>
      {/* ─────────────────── HERO ─────────────────── */}
      <Box
        sx={{
          position: "fixed",
          width: "1px",
          height: "1px",
          background: (theme: Theme) => theme.palette.primary.main,
          top: 0,
          zIndex: 999999999999,
          left: 0,
          borderRadius: "100%",
          animation: "animateCircle1 0.5s",
          animationIterationCount: 1,
          "@keyframes animateCircle1": {
            from: { transform: "scale(4000)" },
            to: { transform: "scale(0)" },
          },
        }}
      ></Box>
      <SectionOneWrapper>
        <Typography variant="h1">DATABASS AI</Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { sm: "row", xs: "column" },
            "& p": {
              fontWeight: 500,
              fontSize: { md: "28px", xs: "22px" },
            },
          }}
        >
          <Typography>GENERATIVE AI FOR MUSIC PRODUCTION</Typography>
        </Box>
      </SectionOneWrapper>

      {/* ─────────────────── SCREENS STRIP ─────────────────── */}
      <SectionTwoWrapper>
        <Box
          sx={{
            display: "flex",
            overflowX: "auto",
            scrollSnapType: "x mandatory",
            "&::-webkit-scrollbar": { display: "none" },
            "& img": {
              height: { lg: "350px", sm: "250px", xs: "180px" },
              width: "auto",
              boxShadow: "4px 0px 20px 0px #66666640",
              borderRadius: "12px",
              cursor: "pointer",
            },
            "& > div": {
              flex: "0 0 auto",
              mr: 2,
              scrollSnapAlign: "start",
            },
          }}
        >
          {images.map((src) => (
            <Box key={src as string} onClick={() => setZoomSrc(src)}>
              <img src={src} alt="databass screen" />
            </Box>
          ))}
        </Box>
      </SectionTwoWrapper>

      {/* ─── ZOOM DIALOG ─────────────────────────────────────────────── */}
      <Dialog
        open={Boolean(zoomSrc)}
        onClose={() => setZoomSrc(null)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { background: "transparent", boxShadow: "none" },
        }}
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            onClick={() => setZoomSrc(null)}
            sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
          >
            <CloseIcon />
          </IconButton>
          {zoomSrc && (
            <img
              src={zoomSrc}
              alt="zoomed screen"
              style={{ width: "100%", height: "auto", borderRadius: "12px" }}
            />
          )}
        </Box>
      </Dialog>
      <SectionThreeWrapper id="section1">
        <Box>
          <Typography
            variant="h3"
            sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 600 }}
          >
            TL;DR
          </Typography>

          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            Early users found Databass AI’s outputs hit-or-miss. I led
            end-to-end product design and strategy to make it understand user
            intent and deliver personalized, reliable results. Scaled to 100K+
            users.
          </Typography>
          <br></br>
          <br></br>
          <Typography
            variant="h3"
            sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 600 }}
          >
            What is Databass AI?
          </Typography>

          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            Databass AI is a generative solution for music production. Primarily
            geared towards music producers (across skill levels), it helps them
            generate the sample audio they need with just a text description,
            eliminating the need for them to browse hundreds of different
            samples.
          </Typography>

          <Box
            sx={{
              py: 3.5,
              px: 4,
              mt: 8,
              background: (theme: Theme) => theme.palette.secondary.main,
            }}
          >
            <Typography
              sx={{
                fontSize: { md: "28px", xs: "22px" },
                fontWeight: 600,
                lineHeight: "33.89px",
              }}
            >
              When I joined, an early beta was live, but users struggled to get
              consistent results. I combined product analytics with targeted
              producer feedback to uncover where outputs broke down.
            </Typography>
          </Box>
        </Box>
        <Box sx={{ mt: 10 }}>
          <Typography
            variant="h3"
            sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 600 }}
          >
            The Problem
          </Typography>

          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            The core challenge was intent capture. Musical genres and terms are
            inherently subjective, and the model lacked a mechanism to ground
            outputs in user preferences. This made generations unreliable,
            forcing frequent restarts.
          </Typography>

          <Typography
            variant="h3"
            sx={{
              fontSize: { md: "28px", xs: "22px" },
              fontWeight: 600,
              mt: 6,
            }}
          >
            Example...
          </Typography>

          <Box
            sx={{
              mt: 2,
              "& svg": {
                width: "fit-content",
                maxWidth: "100%",
                height: "fit-content",
              },
            }}
          >
            <SoundExample />
          </Box>

          <Box
            sx={{
              py: 3.5,
              px: 4,
              mt: 8,
              background: (theme: Theme) => theme.palette.secondary.main,
            }}
          >
            <Typography
              sx={{
                fontSize: { md: "28px", xs: "22px" },
                fontWeight: 600,
                lineHeight: "33.89px",
              }}
            >
              Early users reported inconsistent output quality; generations felt
              hit-or-miss, often requiring restarts.
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mt: 10 }}>
          <Typography
            variant="h3"
            sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 600 }}
          >
            What success looked like
          </Typography>

          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            Success meant improving the first-good output rate, reducing
            rerolls, and shortening the path from idea to usable sample -
            benchmarks we aligned on with the founding team.
          </Typography>
        </Box>

        <SectionEightWrapper id="section2"></SectionEightWrapper>
        <Box sx={{ mt: 10 }}>
          <Typography
            variant="h3"
            sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 600 }}
          >
            My Role
          </Typography>

          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            I operated as both Designer and PM, working side-by-side with the
            co-founder and engineering team. My focus was steering product
            direction - leading research, prioritizing opportunities, setting up the visual design theme, and
            translating insights into prototypes and experiences that scaled.
          </Typography>
        </Box>
      </SectionThreeWrapper>
      <SectionFourWrapper>
        <Typography
          variant="h3"
          sx={{
            fontSize: { md: "40px", sm: "32px", xs: "28px" },
            fontWeight: 700,
            fontFamily: "Mohave",
            fontStyle: "italic",
          }}
        >
          UNDERSTANDING USER BEHAVIOR
        </Typography>

        <Box
          sx={{
            py: 3.5,
            px: 4,
            mt: 5,
            background: (theme: Theme) => theme.palette.secondary.main,
          }}
        >
          <Typography
            sx={{
              fontSize: { md: "28px", xs: "22px" },
              fontWeight: 600,
              lineHeight: "33.89px",
              ml: 2,
            }}
          >
            Through targeted conversations with producers and usage analysis, I
            learned how Databass fit into their workflows
          </Typography>
        </Box>
      </SectionFourWrapper>

      <SectionSevenWrapper>
        <Typography
          variant="h2"
          sx={{
            fontSize: { md: "28px", xs: "22px" },
            fontWeight: 600,
            lineHeight: "33.89px",
            mt: -5,
          }}
        >
          The research surfaced four critical gaps:{" "}
        </Typography>

        <Box>
          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 4 }}>
            <East sx={{ color: "#00E676" }} />{" "}
            <Typography
              sx={{ ml: 1, fontSize: { md: "22px", sm: "18px", xs: "16px" } }}
            >
              <strong>Intent capture: </strong>natural language alone was too
              broad, so the model guessed style.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 4 }}>
            <East sx={{ color: "#00E676" }} />{" "}
            <Typography
              sx={{ ml: 1, fontSize: { md: "22px", sm: "18px", xs: "16px" } }}
            >
              <strong>Iteration pain: </strong>no lightweight way to adjust an
              almost-right sample led to frequent restarts.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 4 }}>
            <East sx={{ color: "#00E676" }} />{" "}
            <Typography
              sx={{ ml: 1, fontSize: { md: "22px", sm: "18px", xs: "16px" } }}
            >
              <strong>Control expectations: </strong>users expected parameters
              like BPM/Key/Mode to mirror their DAWs.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-start", mt: 4 }}>
            <East sx={{ color: "#00E676" }} />{" "}
            <Typography
              sx={{ ml: 1, fontSize: { md: "22px", sm: "18px", xs: "16px" } }}
            >
              <strong>Inspiration need: </strong>prompts and suggestions were
              vital to spark creativity when users felt stuck.
            </Typography>
          </Box>
        </Box>
        <br></br>
        <Box sx={{ mt: 10 }}>
          <Typography
            variant="h3"
            sx={{
              fontSize: { md: "40px", sm: "32px", xs: "28px" },
              fontWeight: 700,
              fontFamily: "Mohave",
              fontStyle: "italic",
            }}
          >
            EXPLORING SOLUTIONS
          </Typography>
          <Typography sx={{ fontSize: { md: "22px", sm: "18px" }, mt: 2.5 }}>
            To move beyond guesswork, I partnered with engineering early to
            evaluate what was technically viable. We tested multiple approaches
            - from adding DAW-like controls to introducing lightweight
            preference signals and quickly prototyped them. By validating with
            producers, we identified which ideas struck the right balance
            between creative freedom and technical feasibility, allowing us to
            narrow in on the most impactful directions without overbuilding.
          </Typography>
          <Box
            sx={{
              py: 3.5,
              px: 4,
              mt: 5,
              background: (theme: Theme) => theme.palette.secondary.main,
            }}
          >
            <Typography
              sx={{
                fontSize: { md: "28px", xs: "22px" },
                fontWeight: 600,
                lineHeight: "33.89px",
                ml: 2,
              }}
            >
              I co-ideated with engineering to check feasibility early, then
              put quick prototypes in front of users to validate direction.
            </Typography>
          </Box>
        </Box>
      </SectionSevenWrapper>
      <SectionEightWrapper id="section3">
        <Typography
          variant="h3"
          sx={{
            fontSize: { md: "40px", sm: "32px", xs: "28px" },
            fontWeight: 700,
            fontFamily: "Mohave",
            fontStyle: "italic",
          }}
        >
          THE SOLUTION
        </Typography>

        <Typography
          sx={{
            fontSize: { md: "28px", sm: "18px" },
            fontWeight: 600,
            color: "text.primary",
            mt: 3,
          }}
        >
          The redesigned experience centered on three principles:{" "}
        </Typography>

        <Box
          sx={{
            py: 3.5,
            px: 4,
            mt: 5,
            background: (theme: Theme) => theme.palette.secondary.main,
          }}
        >
          <Typography
            sx={{
              fontSize: { md: "26px", xs: "20px" },
              fontWeight: 400,
              lineHeight: "33.89px",
              ml: 2,
              color: "black",
            }}
          >
            <ol>
              <li>
                <strong>Personalization -</strong> Producers could now ground
                the AI in their taste by selecting artists or uploading
                reference audio. This shifted generation from generic outputs to
                results that reflected individual style.
              </li>
              <br></br>
              <li>
                <strong>Granular control -</strong> Recognizing that pros wanted
                to refine rather than restart, we added DAW-like parameters
                (BPM, Key, Mode) and quick modifiers (“more bass,” “make it
                happier”). This gave producers familiar levers to adjust outputs
                instead of starting over.
              </li>
              <br></br>
              <li>
                <strong>Assistance -</strong> To help producers get unstuck, we
                introduced lightweight creative nudges: inspiration prompts,
                contextual tips, and an "Shuffle prompt” option. These reduced the
                blank-page problem without overwhelming control.
              </li>
              <br></br>
              
            </ol>
          </Typography>
        </Box>
      </SectionEightWrapper>

      <SectionEightWrapper id="section3">
        {/* Layer 1: Personalization */}
        <Box sx={{ mt: 4 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mt: 1,
              "& div": {
                fontSize: { md: "22px", sm: "18px" },
                fontWeight: 700,
                color: "#000",
                whiteSpace: "nowrap",
              },
            }}
          >
            <br></br>
            <Box
              sx={{ py: 2, px: 3, background: (t) => t.palette.secondary.main }}
            >
              Personalization
            </Box>
          </Box>

          <Box sx={{ mt: 2 }}>
            <Typography
              sx={{ fontWeight: 700, fontSize: { md: "22px", xs: "20px" } }}
            >
              <br></br>
              Taste priming
            </Typography>
            <Typography
              sx={{
                mt: 1,
                fontSize: { md: "22px", xs: "20px" }, // match size
                fontWeight: 400, // match weight
                color: "#000", // force black
              }}
            >
              Let producers pick reference artists so the model anchors style
              instead of guessing.
            </Typography>
            <Box
              sx={{
                mt: 2,
                maxWidth: "900px",
                // border: "1px solid #e0e0e0",
                overflow: "hidden",
                "& img": {
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "contain", // no cropping
                  borderRadius: 4,
                },
              }}
            >
              <img src={Databass100} alt="Taste priming screen 1" />
              <img src={Databass101} alt="Taste priming screen 2" style={{ marginTop: "16px" }} />
            </Box>
          </Box>
          <br></br>
          <br></br>
          <Box sx={{ mt: 2 }}>
            <Typography
              sx={{ fontWeight: 700, fontSize: { md: "22px", xs: "20px" } }}
            >
              <br></br>
              Audio grounding
            </Typography>
            <Typography
              sx={{
                mt: 1,
                fontSize: { md: "22px", xs: "20px" }, // match size
                fontWeight: 400, // match weight
                color: "#000", // force black
              }}
            >
              Upload a clip you like; we encode it to tailor generated audio towards your palette.
            </Typography>
            <Box
              sx={{
                mt: 2,
                maxWidth: "900px",
                overflow: "hidden",
                "& img": {
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "contain", // no cropping
                  borderRadius: 4,

                },
              }}
            >
              <img src={Databass40} alt="" />
            </Box>
          </Box>          
        </Box>
      </SectionEightWrapper>

      <SectionEightWrapper>
        <Typography
          variant="h3"
          sx={{
            fontSize: { md: "40px", sm: "32px", xs: "28px" },
            fontWeight: 700,
            fontFamily: "Mohave",
            fontStyle: "italic",
          }}
        >
          EXAMPLE OF HOW THIS WOULD HELP
        </Typography>

        <Typography
          sx={{
            fontSize: { md: "28px", sm: "18px" },
            fontWeight: 600,
            color: "text.primary",
            mt: 5,
          }}
        >
          Same text prompt used to generate both the files below
        </Typography>

        <Typography
          sx={{
            fontSize: { md: "18px", sm: "14px" },
            fontWeight: 600,
            color: "#000",
            border: "2.5px solid #0021F5",
            borderRadius: "12px",
            p: 1.5,
            mt: 3,
          }}
        >
          A fusion of flamenco and electronic, with passionate guitar strumming
          and digital beats, evoking the modern vibes of Mediterranean nights.
        </Typography>
        <Box>
          <Box sx={{ my: 8 }}>
            <Typography
              sx={{
                fontSize: { md: "28px", sm: "18px" },
                fontWeight: 600,
                color: "text.primary",
              }}
            >
              Music generated by AI <strong>before</strong> the redesign
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: { sm: "row", xs: "column" },
            }}
          >
            <Box
              sx={{
                background: (theme) =>
                  !playing
                    ? theme.palette.secondary.main
                    : theme.palette.primary.main,
                width: "fit-content",
                borderRadius: "50px",
              }}
            >
              {playing ? (
                <IconButton
                  onClick={() => {
                    stop();
                    setPlaying(false);
                  }}
                >
                  <PauseRounded color="secondary" fontSize="large" />
                </IconButton>
              ) : (
                <IconButton
                  onClick={async () => {
                    play();
                    playOptions.stop();
                    setPlaying2(false);
                    setPlaying(true);
                  }}
                >
                  <PlayArrowRounded color="primary" fontSize="large" />
                </IconButton>
              )}
            </Box>
            <Box sx={{ mx: 3, lineHeight: 0 }}>
              {blob && (
                <AudioVisualizer
                  ref={visualizerRef}
                  blob={blob}
                  width={300}
                  height={75}
                  barWidth={4}
                  gap={2}
                  barColor={"#0021F5"}
                  barPlayedColor={"#0021F599"}
                />
              )}
            </Box>
            <Typography
              sx={{ fontSize: "16px", fontWeight: 600, color: "#000" }}
            >
              [NO KNOWLEDGE OF USER’S PREFERENCES]
            </Typography>
          </Box>
        </Box>
        <Box>
          <Box sx={{ my: 8 }}>
            <Typography
              sx={{
                fontSize: { md: "28px", sm: "18px" },
                fontWeight: 600,
                color: "text.primary",
              }}
            >
              Music generated by AI <strong>after</strong> the redesign
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: { sm: "row", xs: "column" },
            }}
          >
            <Box
              sx={{
                background: (theme) =>
                  !playing2
                    ? theme.palette.secondary.main
                    : theme.palette.primary.main,
                width: "fit-content",
                borderRadius: "50px",
              }}
            >
              {playing2 ? (
                <IconButton
                  onClick={() => {
                    playOptions.stop();
                    setPlaying2(false);
                  }}
                >
                  <PauseRounded color="secondary" fontSize="large" />
                </IconButton>
              ) : (
                <IconButton
                  onClick={async () => {
                    play2();
                    stop();
                    setPlaying(false);
                    setPlaying2(true);
                  }}
                >
                  <PlayArrowRounded color="primary" fontSize="large" />
                </IconButton>
              )}
            </Box>
            <Box sx={{ mx: 3, lineHeight: 0 }}>
              {blob2 && (
                <AudioVisualizer
                  ref={visualizer2Ref}
                  blob={blob2}
                  width={300}
                  height={75}
                  barWidth={4}
                  gap={2}
                  barColor={"#0021F5"}
                />
              )}
            </Box>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                color: "#000",
                whiteSpace: { md: "nowrap", xs: "wrap" },
              }}
            >
              [WITH KNOWLEDGE OF USER’S PREFERENCES - HIP BEATS, MODERN]
            </Typography>
          </Box>
        </Box>
      </SectionEightWrapper>

      <SectionEightWrapper id="section3">
        <Box sx={{ mt: 4 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mt: 1,
              "& div": {
                fontSize: { md: "22px", sm: "18px" },
                fontWeight: 700,
                color: "#000",
                whiteSpace: "nowrap",
              },
            }}
          >
            <br></br>
            <Box
              sx={{ py: 2, px: 3, background: (t) => t.palette.secondary.main }}
            >
              Granular control
            </Box>
          </Box>
          <Box sx={{ mt: 2 }}>
            <Typography
              sx={{ fontWeight: 700, fontSize: { md: "22px", xs: "20px" } }}
            >
              <br></br>
              Tweak, don’t restart
            </Typography>
            <Typography
              sx={{
                mt: 1,
                fontSize: { md: "22px", xs: "20px" }, // match size
                fontWeight: 400, // match weight
                color: "#000", // force black
              }}
            >
DAW-like parameters and quick modifiers enable in-place fixes instead of fresh generations.            </Typography>
            <Box
              sx={{
                mt: 2,
                maxWidth: "900px",
                overflow: "hidden",
                "& img": {
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "contain", // no cropping
                  borderRadius: 4,

                },
              }}
            >
              <img src={Databass80} alt="" />
            </Box>
          </Box>      
<br></br>
<Box sx={{ mt: 2 }}>
            <Typography
              sx={{ fontWeight: 700, fontSize: { md: "22px", xs: "20px" } }}
            >
              <br></br>
              <br></br>
              BPM / Key / Mode
            </Typography>
            <Typography
              sx={{
                mt: 1,
                fontSize: { md: "22px", xs: "20px" }, // match size
                fontWeight: 400, // match weight
                color: "#000", // force black
              }}
            >
              Surface core musical controls upfront to match producer expectations and speed.
            </Typography>
            <Box
              sx={{
                mt: 2,
                maxWidth: "900px",
                overflow: "hidden",
                "& img": {
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "contain", // no cropping
                  borderRadius: 4,

                },
              }}
            >
              <img src={Databass60} alt="“Tell me what I’m good at” CTA" />
            </Box>
          </Box>
          <br></br>
           <Box sx={{ mt: 2 }}>
            <Typography
              sx={{ fontWeight: 700, fontSize: { md: "22px", xs: "20px" } }}
            >
              <br></br>
              Modifiers chips
            </Typography>
            <Typography
              sx={{
                mt: 1,
                fontSize: { md: "22px", xs: "20px" }, // match size
                fontWeight: 400, // match weight
                color: "#000", // force black
              }}
            >
One-tap modifiers (like "make it happier") apply safe parameter adjustments behind the scenes, letting producers quickly explore variations without restarting.         </Typography>
            <Box
              sx={{
                mt: 2,
                maxWidth: "900px",
                overflow: "hidden",
                "& img": {
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "contain", // no cropping
                  borderRadius: 4,

                },
              }}
            >
              <img src={Databass70} alt="" />
            </Box>
          </Box>         

          <br></br>
          


          <Box sx={{ mt: 2 }}>
            <Typography
              sx={{ fontWeight: 700, fontSize: { md: "22px", xs: "20px" } }}
            >
              <br></br>
              Compare & learn
            </Typography>
            <Typography
              sx={{
                mt: 1,
                fontSize: { md: "22px", xs: "20px" }, // match size
                fontWeight: 400, // match weight
                color: "#000", // force black
              }}
            >
Show three variations; the user’s pick becomes preference signal, reducing rerolls.           </Typography>
            <Box
              sx={{
                mt: 2,
                maxWidth: "900px",
                overflow: "hidden",
                "& img": {
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "contain", // no cropping
                  borderRadius: 4,

                },
              }}
            >
              <img src={Databass70} alt="" />
            </Box>
          </Box>       
        </Box>
      </SectionEightWrapper>


      <SectionEightWrapper id="section3">
        <Box sx={{ mt: 4 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mt: 1,
              "& div": {
                fontSize: { md: "22px", sm: "18px" },
                fontWeight: 700,
                color: "#000",
                whiteSpace: "nowrap",
              },
            }}
          >
            <br></br>
            <Box
              sx={{ py: 2, px: 3, background: (t) => t.palette.secondary.main }}
            >
              Assistance
            </Box>
          </Box>

          <Box sx={{ mt: 2 }}>
            <Typography
              sx={{ fontWeight: 700, fontSize: { md: "22px", xs: "20px" } }}
            >
              <br></br>
              Assistive flow
            </Typography>
            <Typography
              sx={{
                mt: 1,
                fontSize: { md: "22px", xs: "20px" }, // match size
                fontWeight: 400, // match weight
                color: "#000", // force black
              }}
            >
              Tips, prompts to inspire, and “Inspire me” reduce blank-page friction and keep momentum.
            </Typography>
            <Box
              sx={{
                mt: 2,
                maxWidth: "900px",
                overflow: "hidden",
                "& img": {
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "contain", // no cropping
                  borderRadius: 4,

                },
              }}
            >
              <img src={Databass60} alt="" />
            </Box>
          </Box>
          <br></br>
          <br></br>
       

       {/* Tip Feature */}
       <Box sx={{ mt: 5 }}>
         <Box
           sx={{
             display: "flex",
             alignItems: "center",
             gap: 2,
             cursor: "pointer",
           }}
           onClick={() => toggleExpanded("tip")}
         >
           <Typography
             sx={{ fontSize: { md: "22px", sm: "18px" }, fontWeight: 600 }}
           >
             <b>Tip</b>
           </Typography>
           <Box
             sx={{
               display: "flex",
               alignItems: "center",
               gap: 1,
               px: 2,
               py: 0.5,
               backgroundColor: (theme) => theme.palette.secondary.main,
               color: "#000", 

               borderRadius: "20px",
               fontSize: "14px",
               fontWeight: 500,
             }}
           >
             {expandedItems.tip ? (
               <Remove fontSize="small" />
             ) : (
               <Add fontSize="small" />
             )}
             Click for more info
           </Box>
         </Box>
         {expandedItems.tip && (
           <Typography
           sx={{
             fontSize: { md: "20px", sm: "16px" },
             mt: 2,
             pl: 3,
             borderLeft: "4px solid",
             borderColor: "black",
             backgroundColor: (theme) => theme.palette.secondary.main, 
             color: "#000", 
             py: 2,
             pr: 2,
           }}
         >
             Producers often underspecified prompts, which led to inconsistent generations. To reduce iteration loops, the system detects missing context and proactively requests the single most valuable detail (ex., BPM, Key). This lowered rerolls and improved the first-good-output rate.
           </Typography>
         )}
       </Box>

       {/* Prompts to inspire Feature */}
       <Box sx={{ mt: 5 }}>
         <Box
           sx={{
             display: "flex",
             alignItems: "center",
             gap: 2,
             cursor: "pointer",
           }}
           onClick={() => toggleExpanded("prompts")}
         >
           <Typography
             sx={{ fontSize: { md: "22px", sm: "18px" }, fontWeight: 600 }}
           >
             <b>Prompts to inspire</b>
           </Typography>
           <Box
             sx={{
               display: "flex",
               alignItems: "center",
               gap: 1,
               px: 2,
               py: 0.5,
               backgroundColor: (theme) => theme.palette.secondary.main,
               color: "#000", 

               borderRadius: "20px",
               fontSize: "14px",
               fontWeight: 500,
             }}
           >
             {expandedItems.prompts ? (
               <Remove fontSize="small" />
             ) : (
               <Add fontSize="small" />
             )}
             Click for more info
           </Box>
         </Box>
         {expandedItems.prompts && (
          <Typography
          sx={{
            fontSize: { md: "20px", sm: "16px" },
            mt: 2,
            pl: 3,
            borderLeft: "4px solid",
            borderColor: "black",
            backgroundColor: (theme) => theme.palette.secondary.main, 
            color: "#000", 
            py: 2,
            pr: 2,
          }}
        >
             Blank-page paralysis slowed creative flow. I introduced curated “Inspiration Prompts” that surface diverse starting points aligned with common genres and moods. This nudged producers into exploration faster and ensured broader coverage of the model’s capabilities.
           </Typography>
         )}
       </Box>

       {/* Surprise me Feature */}
       <Box sx={{ mt: 5 }}>
         <Box
           sx={{
             display: "flex",
             alignItems: "center",
             gap: 2,
             cursor: "pointer",
           }}
           onClick={() => toggleExpanded("surprise")}
         >
           <Typography
             sx={{ fontSize: { md: "22px", sm: "18px" }, fontWeight: 600 }}
           >
             <b>Inspire me</b>
           </Typography>
           <Box
             sx={{
               display: "flex",
               alignItems: "center",
               gap: 1,
               px: 2,
               py: 0.5,
               backgroundColor: (theme) => theme.palette.secondary.main,
               color: "#000", 

               borderRadius: "20px",
               fontSize: "14px",
               fontWeight: 500,
             }}
           >
             {expandedItems.surprise ? (
               <Remove fontSize="small" />
             ) : (
               <Add fontSize="small" />
             )}
             Click for more info
           </Box>
         </Box>
         {expandedItems.surprise && (
          <Typography
          sx={{
            fontSize: { md: "20px", sm: "16px" },
            mt: 2,
            pl: 3,
            borderLeft: "4px solid",
            borderColor: "black",
            backgroundColor: (theme) => theme.palette.secondary.main, 
            color: "#000", 
            py: 2,
            pr: 2,
          }}
        >
            Interviews revealed that producers often “play” with tools to spark ideas rather than chase a fixed goal. The Inspire Me function perturbs the input prompt within safe bounds, yielding a distinctly different variation while respecting intent, designed to mimic natural experimentation and keep momentum high.
           </Typography>
         )}
       </Box>

       {/* BPM, Key, Mode Feature */}
       <Box sx={{ mt: 5 }}>
         <Box
           sx={{
             display: "flex",
             alignItems: "center",
             gap: 2,
             cursor: "pointer",
           }}
           onClick={() => toggleExpanded("bpm")}
         >
           <Typography
             sx={{ fontSize: { md: "22px", sm: "18px" }, fontWeight: 600 }}
           >
             <b>BPM, Key, Mode</b>
           </Typography>
           <Box
             sx={{
               display: "flex",
               alignItems: "center",
               gap: 1,
               px: 2,
               py: 0.5,
               backgroundColor: (theme) => theme.palette.secondary.main,
               color: "#000", 

               borderRadius: "20px",
               fontSize: "14px",
               fontWeight: 500,
             }}
           >
             {expandedItems.bpm ? (
               <Remove fontSize="small" />
             ) : (
               <Add fontSize="small" />
             )}
             Click for more info
           </Box>
         </Box>
         {expandedItems.bpm && (
           <Typography
           sx={{
             fontSize: { md: "20px", sm: "16px" },
             mt: 2,
             pl: 3,
             borderLeft: "4px solid",
             borderColor: "black",
             backgroundColor: (theme) => theme.palette.secondary.main, 
             color: "#000", 
             py: 2,
             pr: 2,
           }}
         >
            Core musical attributes (BPM, Key, Mode) were frequently omitted from natural-language prompts, leading to mismatched results. By surfacing these parameters directly in the interface, we aligned with DAW conventions, reduced guesswork, and improved producer trust in the model’s outputs.
           </Typography>
         )}
       </Box>
        </Box>
      </SectionEightWrapper>

      
      



     
     


      <SectionSeventeenWrapper id="section4">
        <Typography
          variant="h3"
          sx={{
            fontSize: { md: "40px", sm: "32px", xs: "28px" },
            fontWeight: 700,
            fontFamily: "Mohave",
            fontStyle: "italic",
            width: "fit-content",
          }}
        >
          IMPACT
        </Typography>
        {/* ───────── SCALING CALLOUT (below both testimonials) ───────── */}
        <Box
          sx={{
            py: 3.5,
            px: 4,
            mt: 4, // space above
            mb: 6, // space below
            background: (theme: Theme) => theme.palette.secondary.main,
            width: "fit-content", // 👈 shrinks box to just the text + padding
          }}
        >
          <Typography
            sx={{
              fontSize: { md: "28px", xs: "22px" },
              fontWeight: 500,
              lineHeight: "33.89px",
              color: "#000", // force black text
            }}
          >
            The redesigned flow helped Databass AI grow to 100K+ users. Producer
            feedback highlighted improved reliability and workflow fit. In
            particular, users reported that personalized generation increased
            satisfaction with first outputs. Internally, this translated into
            higher retention and stronger advocacy from early adopters.
          </Typography>
        </Box>
        <Typography
          sx={{ fontSize: { md: "28px", xs: "22px" }, fontWeight: 600 }}
        >
          <br></br>
          Evidence of impact
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Box
            sx={{
              width: { lg: "640px", xs: "100%" },
              px: 3,
              py: 3.5,
              background: (theme: Theme) => theme.palette.secondary.main,
            }}
          >
            <Typography
              sx={{ fontSize: "24px", fontWeight: 600, color: "#000" }}
            >
              "Prompts to inspire is really useful for my workflow because I
              spend a lot of time finding inspirations"
            </Typography>
          </Box>
          <Box
            sx={{
              width: { lg: "640px", xs: "100%" },
              pl: 3,
              pr: 1,
              py: 1.5,
              background: "#000",
            }}
          >
            <Typography
              sx={{
                fontSize: { lg: "20px", xs: "16px" },
                fontWeight: 400,
                color: (theme: Theme) => theme.palette.secondary.main,
              }}
            >
              -Name is confidential, Music Producer, Los Angeles
            </Typography>
          </Box>
          <Box sx={{ ml: 6, mt: -1 }}>
            <ToolTipIcons />
          </Box>
          {/* CHANGED: Limited image size */}
          <Box sx={{ mt: 3 }}>
            <Box
              component="img"
              src={DatabassUser1}
              alt="no user"
              sx={{
                maxWidth: {
                  lg: "220px",
                  md: "180px",
                  sm: "150px",
                  xs: "120px",
                },
                maxHeight: {
                  lg: "220px",
                  md: "180px",
                  sm: "150px",
                  xs: "120px",
                },
                width: "auto",
                height: "auto",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            top: { lg: "60%", xs: "80%" },
            position: { lg: "absolute" },
            right: 0,
          }}
        >
          <Box
            sx={{
              width: { lg: "640px", xs: "100%" },
              px: 3,
              py: 3.5,
              mt: { lg: 0, xs: 5 },
              background: (theme: Theme) => theme.palette.secondary.main,
            }}
          >
            <Typography
              sx={{ fontSize: "24px", fontWeight: 600, color: "#000" }}
            >
              "Wow! I love that it can understand my personal preferences!"
            </Typography>
          </Box>
          <Box
            sx={{
              width: { lg: "640px", xs: "100%" },
              pl: 3,
              pr: 1,
              py: 1.5,
              background: "#000",
            }}
          >
            <Typography
              sx={{
                fontSize: { lg: "20px", xs: "16px" },
                fontWeight: 400,
                color: (theme: Theme) => theme.palette.secondary.main,
              }}
            >
              -Name is confidential, Music Producer, Los Angeles
            </Typography>
          </Box>
          <Box sx={{ mr: 6, mt: -1, textAlign: "right" }}>
            <ToolTipIcons />
          </Box>
          {/* CHANGED: Limited image size */}
          <Box sx={{ mt: 3, textAlign: "right" }}>
            <Box
              component="img"
              src={DatabassUser2}
              alt="no user"
              sx={{
                maxWidth: {
                  lg: "220px",
                  md: "180px",
                  sm: "150px",
                  xs: "120px",
                },
                maxHeight: {
                  lg: "220px",
                  md: "180px",
                  sm: "150px",
                  xs: "120px",
                },
                width: "auto",
                height: "auto",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            />
          </Box>
        </Box>{" "}
        {/* ← closes the absolute-positioned right testimonial */}
      </SectionSeventeenWrapper>

      {/* <Box sx={{ maxWidth: "1000px", mx: { md: 7.5, xs: 2 }, my: 15 }}>

        <Typography
          variant="h3"
          sx={{
            fontSize: { md: "40px", sm: "32px", xs: "28px" },
            fontWeight: 700,
            fontFamily: "Mohave",
            fontStyle: "italic",
            width: "fit-content",
            // borderBottom: "4px solid",
          }}
        >
          LIMITATION
        </Typography>
        <Typography
          sx={{ fontSize: { md: "22px", sm: "18px" }, color: "#000", mt: 3 }}
        >
          While all the concepts that I designed were technically feasible to
          implement, however, due to the timeline of the design activity (3
          days), we could not build and test them. As an alternate,
          we tested the concept.
        </Typography>
      </Box> */}
    </ProjectWrapper>
  );
};

export default withAuth(Project4);